import { render, staticRenderFns } from "./AppPageSection.vue?vue&type=template&id=6f502972&scoped=true&"
import script from "./AppPageSection.vue?vue&type=script&lang=js&"
export * from "./AppPageSection.vue?vue&type=script&lang=js&"
import style0 from "./AppPageSection.vue?vue&type=style&index=0&id=6f502972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f502972",
  null
  
)

export default component.exports